// extracted by mini-css-extract-plugin
export default {"errorWrapper":"styles_errorWrapper__5JZSJ","positionRelative":"styles_positionRelative__fIzL4","errorIcon":"styles_errorIcon__lNrPx","error":"styles_error__sxpMS"};